import React, { useEffect, useRef } from 'react';
import './result.css';
import a from "../assets/12th result22-23.webp";
import b from "../assets/10th result22-23.webp";
import c from "../assets/2024_Class_10th.webp";
import d from "../assets/2024_Class_12th.webp";
import e from "../assets/12th result24-25.webp";
import f from "../assets/10th result24-25.webp";
import g from "../assets/12th2025-2026 (1).jpeg";
import h from "../assets/10th2025-2026.jpeg";

const ResultsPage = () => {
  const leftRefs = useRef([]);
  const rightRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible'); 
        }
      });
    }, observerOptions);

    leftRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    rightRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="results-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>RESULTS</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Results</li>
          </ul>
        </div>
      </section>

      <div className="content-wrapper">

         {/* 2025-26 Results - Parallel Layout */}
        <div className="results-row">
          {/* 2025-26 */}
           <section className="result-section half-width">
          <h2 className="section-title">RESULTS CLASS XII 2025-26</h2>
           <div className="result-image-card fade-left" ref={el => leftRefs.current[3] = el}>
          <img src={g} alt="Results Class XII 2025-26" className="result-image" />
         </div>
        </section>

         <section className="result-section half-width">
        <h2 className="section-title">RESULTS CLASS X 2025-26</h2>
        <div className="result-image-card fade-right" ref={el => rightRefs.current[3] = el}>
       <img src={h} alt="Results Class X 2025-26" className="result-image" />
        </div>
       </section>

    {/* 2024-25 — index 2, already sahi hai, no change needed */}
        </div>

         {/* 2024-25 Results - Parallel Layout */}
        <div className="results-row">
          {/* Class XII 2024-25 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS XII 2024-25</h2>
            <div 
              className="result-image-card fade-left"
              ref={el => leftRefs.current[2] = el}
            >
              <img 
                src={e}
                alt="Results Class XII 2024-25" 
                className="result-image"
              />
            </div>
          </section>

          {/* Class X 2023-24 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS X 2024-25</h2>
            <div 
              className="result-image-card fade-right"
              ref={el => rightRefs.current[2] = el}
            >
              <img 
                src={f} 
                alt="Results Class X 2024-25" 
                className="result-image"
              />
            </div>
          </section>
        </div>


        {/* 2023-24 Results - Parallel Layout */}
        <div className="results-row">
          {/* Class XII 2023-24 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS XII 2023-24</h2>
            <div 
              className="result-image-card fade-left"
              ref={el => leftRefs.current[0] = el}
            >
              <img 
                src={d}
                alt="Results Class XII 2023-24" 
                className="result-image"
              />
            </div>
          </section>

          {/* Class X 2023-24 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS X 2023-24</h2>
            <div 
              className="result-image-card fade-right"
              ref={el => rightRefs.current[0] = el}
            >
              <img 
                src={c} 
                alt="Results Class X 2023-24" 
                className="result-image"
              />
            </div>
          </section>
        </div>

        {/* 2022-23 Results - Parallel Layout */}
        <div className="results-row">
          {/* Class XII 2022-23 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS XII 2022-23</h2>
            <div 
              className="result-image-card fade-left"
              ref={el => leftRefs.current[1] = el}
            >
              <img 
                src={a}
                alt="Results Class XII 2022-23" 
                className="result-image"
              />
            </div>
          </section>

          {/* Class X 2022-23 */}
          <section className="result-section half-width">
            <h2 className="section-title">RESULTS CLASS X 2022-23</h2>
            <div 
              className="result-image-card fade-right"
              ref={el => rightRefs.current[1] = el}
            >
              <img 
                src={b}
                alt="Results Class X 2022-23" 
                className="result-image"
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ResultsPage;